import { c as _c } from "react/compiler-runtime";
import { ConsolidatedTDH, TDH, TDHBoostBreakdown } from "@/entities/ITDH";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import { Tooltip } from "react-tooltip";
export default function UserPageStatsBoostBreakdown(t0) {
  const $ = _c(12);
  const {
    tdh
  } = t0;
  if (!tdh?.boost_breakdown || !tdh.boost) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function getMemeRow(name, breakdown) {
      return <tr key={getRandomObjectId()}><td className="tw-px-8 sm:tw-px-10 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400">{name}</td><td className="tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-white-400 tw-text-center">{breakdown?.available ? <span className="d-flex align-items-center justify-content-center gap-2">{breakdown.available.toFixed(2)}<BoostBreakdownInfo info={breakdown.available_info} /></span> : "-"}</td><td className="tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-white-400 tw-text-center">{breakdown?.acquired ? <span className="d-flex align-items-center justify-content-center gap-2">{breakdown.acquired.toFixed(2)}<BoostBreakdownInfo info={breakdown.acquired_info} /></span> : "-"}</td></tr>;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getMemeRow = t1;
  let t2;
  if ($[2] !== tdh?.boost_breakdown) {
    t2 = function getMemesRows() {
      const headerRow = <tr key={getRandomObjectId()}><td className="tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-pt-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-white-400">Memes</td></tr>;
      const bb = tdh?.boost_breakdown;
      if (!bb) {
        return [headerRow];
      }
      const baseRows = [headerRow, getMemeRow("Full Collection Set", bb.memes_card_sets)];
      if (bb.memes_card_sets?.acquired !== 0) {
        return baseRows;
      }
      const extraRows = [getMemeRow("SZN1", bb.memes_szn1), ...(bb.memes_szn1?.acquired ? [] : [getMemeRow("Genesis Set", bb.memes_genesis), getMemeRow("Nakamoto", bb.memes_nakamoto)]), getMemeRow("SZN2", bb.memes_szn2), getMemeRow("SZN3", bb.memes_szn3), getMemeRow("SZN4", bb.memes_szn4), getMemeRow("SZN5", bb.memes_szn5), getMemeRow("SZN6", bb.memes_szn6), getMemeRow("SZN7", bb.memes_szn7), getMemeRow("SZN8", bb.memes_szn8), getMemeRow("SZN9", bb.memes_szn9), getMemeRow("SZN10", bb.memes_szn10), getMemeRow("SZN11", bb.memes_szn11), getMemeRow("SZN12", bb.memes_szn12)];
      return [...baseRows, ...extraRows];
    };
    $[2] = tdh?.boost_breakdown;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getMemesRows = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function getBaseBoostRow(name_0, breakdown_0) {
      if (breakdown_0) {
        return <tr key={getRandomObjectId()}><td className="tw-border-t tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-iron-800 tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-white-400">{name_0}</td><td className="tw-border-t tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-iron-800 tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-white-400 tw-text-center">{breakdown_0.available ? <span className="d-flex align-items-center justify-content-center gap-2">{breakdown_0.available.toFixed(2)}<BoostBreakdownInfo info={breakdown_0.available_info} /></span> : "-"}</td><td className="tw-border-t tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-iron-800 tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-white-400 tw-text-center">{breakdown_0.acquired ? <span className="d-flex align-items-center justify-content-center gap-2">{breakdown_0.acquired.toFixed(2)}<BoostBreakdownInfo info={breakdown_0.acquired_info} /></span> : "-"}</td></tr>;
      }
      return <></>;
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getBaseBoostRow = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-flex tw-items-center tw-justify-between"><h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Boost Breakdown</h3><span><Link href="/network/tdh#tdh-1-4" className="decoration-hover-underline tw-text-sm">TDH Version: 1.4</Link></span></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <thead className="tw-bg-iron-900 tw-border-b tw-border-iron-700 tw-border-x-0 tw-border-t-0"><tr key={getRandomObjectId()}><th scope="col" className="tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400">Type</th><th scope="col" className="tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400  tw-text-center">Potential Boost</th><th scope="col" className="tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400 tw-text-center">Actual Boost</th></tr></thead>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== getMemesRows || $[8] !== tdh) {
    t6 = tdh?.boost_breakdown && <>{getMemesRows()}{getBaseBoostRow("Gradients", tdh?.boost_breakdown.gradients)}<tr key={getRandomObjectId()}><td className="tw-border-t tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-iron-700 tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-semibold tw-text-white-400">TOTAL BOOST</td><td className="tw-border-t tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-iron-700 tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-white-400 tw-text-center">{tdh?.boost ? <span className="d-flex align-items-center justify-content-center gap-2">{(tdh.boost_breakdown.memes_card_sets.available + tdh.boost_breakdown.gradients.available).toFixed(2)}<BoostBreakdownInfo info={["Total Potential Boost"]} /></span> : "-"}</td><td className="tw-border-t tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-iron-700 tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-white-400 tw-text-center">{tdh?.boost ? <span className="d-flex align-items-center justify-content-center gap-2">{(Math.round((tdh.boost - 1) * 100) / 100).toFixed(2)}<BoostBreakdownInfo info={["Total Actual Boost"]} /></span> : "-"}</td></tr></>;
    $[7] = getMemesRows;
    $[8] = tdh;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div className="tw-mt-6 lg:tw-mt-8">{t4}<div className="tw-mt-2 lg:tw-mt-4 tw-bg-iron-950 tw-border tw-border-iron-700 tw-border-solid tw-rounded-lg tw-overflow-x-auto"><div className="tw-flow-root"><div className="tw-inline-block tw-min-w-full tw-align-middle"><table className="tw-min-w-full">{t5}<tbody>{t6}</tbody></table></div></div></div></div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function BoostBreakdownInfo(t0) {
  const $ = _c(8);
  const {
    info
  } = t0;
  if (!info || info.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getRandomObjectId();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tooltipId = `boost-info-${t1}`;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FontAwesomeIcon icon={faInfoCircle} height={16} color="lightgrey" cursor="pointer" data-tooltip-id={tooltipId} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px",
      zIndex: 10
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== info) {
    t4 = info.length > 1 ? <ul className="mb-0" style={{
      paddingLeft: "1rem",
      textAlign: "left"
    }}>{info.map(_temp)}</ul> : info[0];
    $[4] = info;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <>{t2}<Tooltip id={tooltipId} place="top" style={t3}>{t4}</Tooltip></>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp(i) {
  return <li key={getRandomObjectId()} className="text-left">{i}</li>;
}